
const getAccessToken = () => sessionStorage.getItem('accessToken')

const setAccessToken = val =>{
    sessionStorage.setItem('accessToken',val)
}

export {getAccessToken,setAccessToken}